import LegalPage, { Section, useCompany } from "@/components/public/LegalPage";
import { useConsent, resetConsent } from "@/lib/consent";

export default function Cookies() {
  const co = useCompany();
  const consent = useConsent();
  return (
    <LegalPage title="Cookie Policy" testid="cookies-page">
      <p className="text-slate-600">This policy explains how {co.name} uses cookies and similar storage on this website.</p>
      <Section title="Strictly necessary">
        <p>We store your cookie choice in your browser so we don't ask you again. If you log in to the admin area, a secure session cookie keeps you signed in. These are needed for the site to work and don't require consent.</p>
      </Section>
      <Section title="Third-party map (optional)">
        <p>Our About page can show a map from OpenStreetMap. It is only loaded if you accept cookies, as OpenStreetMap may set its own cookies and receive your IP address.</p>
      </Section>
      <Section title="Analytics and advertising">
        <p>We do not use analytics, tracking or advertising cookies.</p>
      </Section>
      <Section title="Change your choice">
        <p>Your current choice: <strong data-testid="cookies-current-choice">{consent || "not set"}</strong>.</p>
        <button onClick={resetConsent} className="rounded-full bg-slate-900 px-6 py-2.5 text-sm font-bold text-white hover:bg-green-700 transition-colors" data-testid="cookies-change-btn">
          Change cookie settings
        </button>
      </Section>
    </LegalPage>
  );
}
